export var baseMenuTheme = {
  baseStyle: _ref => {
    var {
      width,
      maxHeight,
      position,
      top,
      left
    } = _ref;
    return {
      dropdown: {
        width,
        overflow: 'hidden',
        borderRadius: 'l',
        boxShadow: 500,
        border: 'basic.light',
        backgroundColor: 'neutral.white',
        position,
        top: "".concat(top !== null && top !== void 0 ? top : 0, "px"),
        left: "".concat(left !== null && left !== void 0 ? left : 0, "px"),
        _focusVisible: {
          outline: 'none'
        }
      },
      content: {
        paddingY: 'xs',
        maxHeight,
        overflow: 'auto',
        display: 'flex',
        flexDirection: 'column'
      },
      item: {
        width: '100%',
        transition: 'background-color 0.1s ease-in-out',
        _hover: {
          backgroundColor: 'neutral.lightest',
          cursor: 'pointer'
        },
        _selected: {
          backgroundColor: 'neutral.lightest'
        },
        _disabled: {
          backgroundColor: 'unset',
          cursor: 'not-allowed'
        },
        _focusVisible: {
          outlineColor: 'focus.focus',
          // So the outline won't be cropped by the menu container
          outlineOffset: '-1px'
        }
      }
    };
  }
};
//# sourceMappingURL=BaseMenu.theme.js.map